import React, { ReactElement } from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import ProtectedRoute from "./protectedRoute";
import PublicRoute from "./publicRoute";

import Home from "../pages/home/home.component";
import Login from "../pages/auth/login.component";

import Register from "../pages/auth/register.component";
import ForgotPassword from "../pages/auth/forgotpassword.component";
import ResetPassword from "../pages/auth/resetpassword.component";
import EventPage from "../pages/event/event.component";
import ReplayPage from "../pages/event/replay.component";
import NotFoundPage from "../pages/error/404.page";

export default (): ReactElement => {
  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/login" component={Login} />
        <PublicRoute exact path="/register" component={Register} />
        <PublicRoute exact path="/forgot-password" component={ForgotPassword} />
        <PublicRoute exact path="/auth" component={ResetPassword} />

        <ProtectedRoute exact path="/" component={Home} />
        <ProtectedRoute exact path="/live" component={EventPage} />
        <ProtectedRoute
          exact
          path="/replay/:sessionId?"
          component={ReplayPage}
        />

        <Route path="/404" component={NotFoundPage} />
        <Redirect from="*" to="/404" />
      </Switch>
    </Router>
  );
};
